/**
 * 将 outcomes array 转变成 map
 * @param  {Array}  outcomes  outcomes list
 * @return {Object}         { order: [[outcomeId]], map: {} }, order 记录了原始列表顺序，map 是 outcome 数据对象
 */
export const turnOutcomesToMap = (outcomes = []) => {
  const order = []
  const map = {}
  outcomes.forEach((outcome) => {
    const { id } = outcome
    order.push(outcome.id)
    map[id] = outcome
  })
  return { order, map }
}

/**
 * 将 markets array 转变成 map
 * @param  {Array}  markets  markets list
 * @return {Object}         { order: [[marketId]], map: {} }, order 记录了原始列表顺序，map 是 market 数据对象
 */
export const turnMarketsToMap = (markets = []) => {
  const order = []
  const map = {}
  markets.forEach((market) => {
    const { id, outcomes, ...rest } = market

    if (!order.includes(id)) {
      order.push(id)
    }

    const result = {
      id,
      outcomes: turnOutcomesToMap(outcomes),
      ...rest
    }

    // specifiers
    if (market.specifiers) {
      if (map[id]) {
        map[id].push(result)
      } else {
        map[id] = [result]
      }
    } else {
      map[id] = result
    }
  })
  return { order, map }
}

/**
 * 将 events array 转变成 map
 * @param  {Array}  events  events list
 * @return {Object}         { order: [[eventId]], map: {} }, order 记录了原始列表顺序，map 是 event 数据对象
 */
export const turnEventsToMap = (events = []) => {
  const order = []
  const map = {}
  events.forEach((event) => {
    const { eventId, markets, ...rest } = event
    order.push(eventId)
    map[eventId] = {
      eventId,
      markets: turnMarketsToMap(markets),
      ...rest
    }
  })
  return { order, map }
}

/**
 * 将 categories array 转变成 map
 * @param  {Array}  categories  categories list
 * @return {Object}              { order: [[categoryId]], map: {} }, order 记录了原始列表顺序，map 是 category 数据对象
 */
export const turnCategoriesToMap = (categories = []) => {
  const order = []
  const map = {}
  categories.forEach((category) => {
    const { categoryId, events, ...rest } = category
    order.push(categoryId)
    map[categoryId] = {
      categoryId,
      events: turnEventsToMap(events),
      ...rest
    }
  })
  return { order, map }
}

/**
 * 将 tournaments array 转变成 map
 * @param  {Array}  tournaments  tournaments list
 * @return {Object}              { order: [[tournamentId]], map: {} }, order 记录了原始列表顺序，map 是 tournament 数据对象
 */
export const turnTournamentsToMap = (tournaments = []) => {
  const order = []
  const map = {}
  tournaments.forEach((tournament) => {
    const { tournamentId, events, ...rest } = tournament
    order.push(tournamentId)
    map[tournamentId] = {
      tournamentId,
      events: turnEventsToMap(events),
      ...rest
    }
  })
  return { order, map }
}
